import { render, staticRenderFns } from "./AddEditMain.vue?vue&type=template&id=58c1a425"
import script from "./AddEditMain.vue?vue&type=script&lang=js"
export * from "./AddEditMain.vue?vue&type=script&lang=js"
import style0 from "./AddEditMain.vue?vue&type=style&index=0&id=58c1a425&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports